export default __webpack_public_path__ + "static/media/creditcardv2.bb8b18f4.png";